import axios from '@/utils/request';

// 获取司机详情
export const getDriverInfo = (id) => {
    return axios.get(`/system/driver/getDriverInfo/${id}`)
}

// 获取司机列表
export const getDriverList = (params) => {
    return axios.get(`/system/driver/getDriverList`, { params })
}